<template>
  <div id="func-47888" v-if="funcionalidade">
    <FuncionalidadeHeader :titulo="funcionalidade.nome"/>
    <el-row class="usuario">
      <el-col class="img-usuario">
        <svgIcone :cor="estilo.aplicacao.corPrimariaAplicacao" icone="avatar_empty"></svgIcone>
      </el-col>
      <el-col class="dados-usuario">
        <p class="nome">{{ nomeUsuario }}</p>
        <p style="margin: 0" v-if="idadeUsuario">{{ idadeUsuario }}</p>
      </el-col>
    </el-row>
    <MenuVertical :columns="columns" :width="'610px'"/>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import MenuVertical from '@/components/MenuVertical/MenuVertical'

export default {
  name: 'Func47888Perfil',
  components: {
    FuncionalidadeHeader,
    MenuVertical
  },
  data () {
    return {
      possuiFoto: false
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiAcesso', 'frameId']),
    ...mapGetters('Login', ['user', 'nomeUsuario', 'idadeUsuario']),
    ...mapGetters('SetupApp', ['estilo', 'configuracaoAcesso']),
    columns () {
      const lista = []

      if (this.configuracaoAcesso.meusProtocolos && this.configuracaoAcesso.meusProtocolos.ativo) {
        lista.push({
          title: 'Meus Protocolos',
          action: this.openProtocolos
        })
      }
      if (this.configuracaoAcesso.PINSS && this.configuracaoAcesso.PINSS.ativo) {
        lista.push({
          title: 'Informações do Plano (PIN-SS)',
          action: this.openPinss
        })
      }

      if (this.configuracaoAcesso.trocarSenha && this.configuracaoAcesso.trocarSenha.ativo) {
        lista.push({
          title: 'Alterar senha',
          action: this.goToTrocarSenha
        })
      }

      lista.push({
        title: 'Termos de uso',
        action: this.openTermoDeUso
      })

      lista.push({
        title: 'Logout',
        action: this.logout
      })

      return lista
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapMutations('SetupApp', ['SET_ESQUEMA_DE_COR']),
    ...mapActions('Login', ['initialState']),
    async init () {},
    removeFoto () {
      this.possuiFoto = false
    },
    teste () {
      this.possuiFoto = true
    },
    goToTrocarSenha () {
      this.$router.push({ path: `/138` })
    },
    openTermoDeUso () {
      this.$router.push({ path: `/termosDeUso`,
        query: {
          idTermo: this.configuracaoAcesso.login.parametros.idTermosUso
        } })
    },
    openProtocolos () {
      this.$router.push({ path: '/49' })
    },
    openPinss () {
      this.$router.push({ path: '/52' })
    },
    async logout () {
      await this.apiAcesso.login.logout()
      this.initialState()
      this.sendLogoutMessage()
    },
    sendLogoutMessage () {
      const payload = {
        origin: 'omnichannel',
        client: this.frameId,
        type: 'command',
        command: 'LOGOUT',
        data: {},
        timestamp: Date.now()
      }
      window.parent.postMessage(payload, '*')
    }
  }
}
</script>
